document.addEventListener("DOMContentLoaded", ()=>{
    document.querySelectorAll(".skill-category .category-header").forEach((header)=>{
        header.addEventListener("click", ()=>{
            const category = header.parentElement;
            // Toggle open class
            category.classList.toggle("open");
            // Close siblings if you want only one open at a time:
            document.querySelectorAll(".skill-category").forEach((cat)=>{
                if (cat !== category) cat.classList.remove("open");
            });
        });
    });
});

//# sourceMappingURL=repo.95bb3547.js.map
